import { t } from "@/utils";
import { useEventDeletion } from "viewer/store/eventDeletion";
import IconButton from "@/components/IconButton";
import Select from "assets/icons/select.svg?react";

export default function DeletionButtons() {
  const { isInDeletionMode, toggleDeletionMode } = useEventDeletion((s) => ({
    isInDeletionMode: s.isInDeletionMode,
    toggleDeletionMode: s.toggleDeletionMode
  }));

  return (
    <>
      <IconButton
        bg={isInDeletionMode ? "primary-container" : "transparent"}
        icon={Select}
        fill="on-surface"
        onClick={toggleDeletionMode}
        tooltip={{ label: t("select") }}
      />
    </>
  );
}
